import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Navigation from "./Navigation";
import headerImage from "../../../assets/images/profile/pic1.jpg";
import avatar1 from "../../../assets/images/avatar/1.jpg";
import Key from "../icons/Key";
import Profile from "../icons/Profile";
import LogOut from "../icons/LogOut";
import CryptoJS from "crypto-js";
import { useDispatch, useSelector } from "react-redux";
import { data } from "../../../slice/adminSlice";

const Header = (props) => {
  const nav = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [pathTitle, setPathTitle] = useState("Dashboard");
  const [id, setId] = useState("");
  const [adminDetails, setAdminDetails] = useState({});
  const details = useSelector((state) => state.adminDetails);
  const logoutHandler = async () => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}logout`, {
      credentials: "include",
    });
    if (response.status === 200) {
      nav("/");
      return;
    }
  };

  const bellLinkClickHandler = (e) => {
    props.onClick(e);
  };

  let user = "";
  let bytes = "";

  useEffect(() => {
    Navigation.forEach((el) => {
      if (el.link === location.pathname) {
        setPathTitle(el.title);
      } else {
        if (el.submenu && el.submenu.length > 0) {
          el.submenu.forEach((e) => {
            if (e.link === location.pathname) {
              setPathTitle(e.title);
            }
          });
        }
      }
    });

    user = localStorage.getItem("user");
    bytes = CryptoJS.AES.decrypt(user, "thisistest");
    const adminId = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    setId(adminId.id);

    try {
      (async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}get-admin`, {
          method: "POST",
          body: JSON.stringify({ id: adminId.id }),
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.status === 200) {
          const result = await response.json();
          dispatch(data(result.details[0]));
          setAdminDetails(result.details[0]);
        }
      })();
    } catch (error) {
      console.log(error);
    }
  }, [location]);

  useEffect(() => {
    setAdminDetails(details.data);
  }, [details]);

  return (
    <React.Fragment>
      <div className="header">
        <div className="header-content">
          <nav className="navbar navbar-expand">
            <div className="collapse navbar-collapse justify-content-between">
              <div className="header-left">
                <div className="dashboard_bar">{pathTitle}</div>
                <div className="nav-item d-flex align-items-center">
                  {/* <div className="input-group search-area">
                    <input
                      type="text"
                      className="form-control"
                      placeholder=""
                    />
                    <span className="input-group-text">
                      <a href="#header">
                        <i className="flaticon-381-search-2" />
                      </a>
                    </span>
                  </div> */}
                  {/* <div className="plus-icon">
                    <a href="#header">
                      <i className="fas fa-plus" />
                    </a>
                  </div> */}
                </div>
              </div>
              <ul className="navbar-nav header-right">
                {/* <li className="nav-item dropdown notification_dropdown">
                  <Link
                    className="nav-link bell-link "
                    onClick={() => bellLinkClickHandler(props.showChtBox)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height="22.871"
                      viewBox="0 0 24 22.871"
                    >
                      <g data-name="Layer 2" transform="translate(-2 -2)">
                        <path
                          id="Path_9"
                          data-name="Path 9"
                          d="M23.268,2H4.73A2.733,2.733,0,0,0,2,4.73V17.471A2.733,2.733,0,0,0,4.73,20.2a.911.911,0,0,1,.91.91v1.94a1.82,1.82,0,0,0,2.83,1.514l6.317-4.212a.9.9,0,0,1,.5-.153h4.436a2.742,2.742,0,0,0,2.633-2L25.9,5.462A2.735,2.735,0,0,0,23.268,2Zm.879,2.978-3.539,12.74a.915.915,0,0,1-.88.663H15.292a2.718,2.718,0,0,0-1.514.459L7.46,23.051v-1.94a2.733,2.733,0,0,0-2.73-2.73.911.911,0,0,1-.91-.91V4.73a.911.911,0,0,1,.91-.91H23.268a.914.914,0,0,1,.879,1.158Z"
                          transform="translate(0 0)"
                        />
                        <path
                          id="Path_10"
                          data-name="Path 10"
                          d="M7.91,10.82h4.55a.91.91,0,1,0,0-1.82H7.91a.91.91,0,1,0,0,1.82Z"
                          transform="translate(-0.45 -0.63)"
                        />
                        <path
                          id="Path_11"
                          data-name="Path 11"
                          d="M16.1,13H7.91a.91.91,0,1,0,0,1.82H16.1a.91.91,0,1,0,0-1.82Z"
                          transform="translate(-0.45 -0.99)"
                        />
                      </g>
                    </svg>
                    <span className="badge light text-white bg-primary rounded-circle">
                      76
                    </span>
                  </Link>
                </li> */}
                {/* <li className="nav-item dropdown notification_dropdown">
                  <a
                    className="nav-link"
                    href="#header"
                    role="button"
                    data-bs-toggle="dropdown"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                    >
                      <g data-name="Layer 2" transform="translate(-2 -2)">
                        <path
                          id="Path_20"
                          data-name="Path 20"
                          d="M22.571,15.8V13.066a8.5,8.5,0,0,0-7.714-8.455V2.857a.857.857,0,0,0-1.714,0V4.611a8.5,8.5,0,0,0-7.714,8.455V15.8A4.293,4.293,0,0,0,2,20a2.574,2.574,0,0,0,2.571,2.571H9.8a4.286,4.286,0,0,0,8.4,0h5.23A2.574,2.574,0,0,0,26,20,4.293,4.293,0,0,0,22.571,15.8ZM7.143,13.066a6.789,6.789,0,0,1,6.78-6.78h.154a6.789,6.789,0,0,1,6.78,6.78v2.649H7.143ZM14,24.286a2.567,2.567,0,0,1-2.413-1.714h4.827A2.567,2.567,0,0,1,14,24.286Zm9.429-3.429H4.571A.858.858,0,0,1,3.714,20a2.574,2.574,0,0,1,2.571-2.571H21.714A2.574,2.574,0,0,1,24.286,20a.858.858,0,0,1-.857.857Z"
                        />
                      </g>
                    </svg>
                    <span className="badge light text-white bg-primary rounded-circle">
                      4
                    </span>
                  </a>
                  <div className="dropdown-menu dropdown-menu-end">
                    <div
                      id="DZ_W_Notification1"
                      className="widget-media dlab-scroll p-3"
                      style={{ height: 380 }}
                    >
                      <ul className="timeline">
                        <li>
                          <div className="timeline-panel">
                            <div className="media me-2">
                              <img width={50} src={avatar1} alt="headerImage" />
                            </div>
                            <div className="media-body">
                              <h6 className="mb-1">
                                Dr sultads Send you Photo
                              </h6>
                              <small className="d-block">
                                29 July 2020 - 02:26 PM
                              </small>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="timeline-panel">
                            <div className="media me-2 media-info">KG</div>
                            <div className="media-body">
                              <h6 className="mb-1">
                                Resport created successfully
                              </h6>
                              <small className="d-block">
                                29 July 2020 - 02:26 PM
                              </small>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="timeline-panel">
                            <div className="media me-2 media-success">
                              <i className="fa fa-home" />
                            </div>
                            <div className="media-body">
                              <h6 className="mb-1">
                                Reminder : Treatment Time!
                              </h6>
                              <small className="d-block">
                                29 July 2020 - 02:26 PM
                              </small>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="timeline-panel">
                            <div className="media me-2">
                              <img alt="headerImage" width={50} src={avatar1} />
                            </div>
                            <div className="media-body">
                              <h6 className="mb-1">
                                Dr sultads Send you Photo
                              </h6>
                              <small className="d-block">
                                29 July 2020 - 02:26 PM
                              </small>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="timeline-panel">
                            <div className="media me-2 media-danger">KG</div>
                            <div className="media-body">
                              <h6 className="mb-1">
                                Resport created successfully
                              </h6>
                              <small className="d-block">
                                29 July 2020 - 02:26 PM
                              </small>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="timeline-panel">
                            <div className="media me-2 media-primary">
                              <i className="fa fa-home" />
                            </div>
                            <div className="media-body">
                              <h6 className="mb-1">
                                Reminder : Treatment Time!
                              </h6>
                              <small className="d-block">
                                29 July 2020 - 02:26 PM
                              </small>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <a className="all-notification" href="#header">
                      See all notifications <i className="ti-arrow-end" />
                    </a>
                  </div>
                </li> */}
                <li className="nav-item">
                  <Link className="nav-link" to="/admin/general-settings">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="23.262"
                      height={24}
                      viewBox="0 0 23.262 24"
                    >
                      <g id="icon" transform="translate(-1565 90)">
                        <path
                          id="setting_1_"
                          data-name="setting (1)"
                          d="M30.45,13.908l-1-.822a1.406,1.406,0,0,1,0-2.171l1-.822a1.869,1.869,0,0,0,.432-2.385L28.911,4.293a1.869,1.869,0,0,0-2.282-.818l-1.211.454a1.406,1.406,0,0,1-1.88-1.086l-.213-1.276A1.869,1.869,0,0,0,21.475,0H17.533a1.869,1.869,0,0,0-1.849,1.567L15.47,2.842a1.406,1.406,0,0,1-1.88,1.086l-1.211-.454a1.869,1.869,0,0,0-2.282.818L8.126,7.707a1.869,1.869,0,0,0,.432,2.385l1,.822a1.406,1.406,0,0,1,0,2.171l-1,.822a1.869,1.869,0,0,0-.432,2.385L10.1,19.707a1.869,1.869,0,0,0,2.282.818l1.211-.454a1.406,1.406,0,0,1,1.88,1.086l.213,1.276A1.869,1.869,0,0,0,17.533,24h3.943a1.869,1.869,0,0,0,1.849-1.567l.213-1.276a1.406,1.406,0,0,1,1.88-1.086l1.211.454a1.869,1.869,0,0,0,2.282-.818l1.972-3.415a1.869,1.869,0,0,0-.432-2.385ZM27.287,18.77l-1.211-.454a3.281,3.281,0,0,0-4.388,2.533l-.213,1.276H17.533l-.213-1.276a3.281,3.281,0,0,0-4.388-2.533l-1.211.454L9.75,15.355l1-.822a3.281,3.281,0,0,0,0-5.067l-1-.822L11.721,5.23l1.211.454A3.281,3.281,0,0,0,17.32,3.151l.213-1.276h3.943l.213,1.276a3.281,3.281,0,0,0,4.388,2.533l1.211-.454,1.972,3.414h0l-1,.822a3.281,3.281,0,0,0,0,5.067l1,.822ZM19.5,7.375A4.625,4.625,0,1,0,24.129,12,4.63,4.63,0,0,0,19.5,7.375Zm0,7.375A2.75,2.75,0,1,1,22.254,12,2.753,2.753,0,0,1,19.5,14.75Z"
                          transform="translate(1557.127 -90)"
                        />
                      </g>
                    </svg>
                  </Link>
                </li>
                <li className="nav-item dropdown header-profile">
                  <a
                    className="nav-link"
                    href="#header"
                    role="button"
                    data-bs-toggle="dropdown"
                  >
                    {adminDetails && adminDetails.profile && (
                      <img
                        src={process.env.REACT_APP_IMAGE_URL + "profile-images/" + adminDetails.profile}
                        width={20}
                        alt=""
                      />
                    )}
                    {!adminDetails ||
                      (adminDetails.profile === "" && (
                        <img src={headerImage} width={20} alt="" />
                      ))}
                  </a>
                  <div className="dropdown-menu dropdown-menu-end">
                    <Link
                      to="/admin/admin-profile"
                      className="dropdown-item ai-icon"
                    >
                      <Profile />
                      <span className="ms-2">Profile </span>
                    </Link>
                    <Link
                      to="/admin/change-password"
                      className="dropdown-item ai-icon"
                    >
                      <Key />
                      <span className="ms-2">Change Password</span>
                    </Link>
                    <div
                      className="dropdown-item ai-icon"
                      onClick={logoutHandler}
                    >
                      <LogOut />
                      <span className="ms-2">Logout </span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Header;
